import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import { LoadingButton } from '@mui/lab';
import { Button, Stack, TextField } from '@mui/material';

import { AIRPORT_CODE_LENGTH } from '../CharterFeederPricesConstants';

interface CharterFeederToolbarProps {
  isViewMode: boolean;
  isSaving: boolean;
  isDataLoading: boolean;
  newFeederCode: string;
  onNewFeederCodeChange: (value: string) => void;
  onEnterEditMode: () => void;
  onExitEditMode: () => void;
  onSave: () => void;
  onAddFeederColumn: () => void;
  onOpenAddRowDialog: () => void;
}

export default function CharterFeederToolbar({
  isViewMode,
  isSaving,
  isDataLoading,
  newFeederCode,
  onNewFeederCodeChange,
  onEnterEditMode,
  onExitEditMode,
  onSave,
  onAddFeederColumn,
  onOpenAddRowDialog,
}: CharterFeederToolbarProps): React.JSX.Element {
  return (
    <Stack spacing={3}>
      <Stack direction="row" justifyContent="flex-start" alignItems="center">
        <Stack direction="row" spacing={2}>
          <Button variant="outlined" size="small" onClick={isViewMode ? onEnterEditMode : onExitEditMode}>
            {isViewMode ? 'Edit' : 'View Mode'}
          </Button>

          {!isViewMode && (
            <LoadingButton
              variant="contained"
              size="small"
              loading={isSaving}
              disabled={isSaving || isDataLoading}
              onClick={onSave}
            >
              Save Changes
            </LoadingButton>
          )}
        </Stack>
      </Stack>

      {!isViewMode && (
        <Stack direction="row" spacing={2} alignItems="center">
          <TextField
            label="Feeder origin code"
            size="small"
            value={newFeederCode}
            onChange={(event) => onNewFeederCodeChange(event.target.value)}
            slotProps={{ htmlInput: { maxLength: AIRPORT_CODE_LENGTH } }}
          />
          <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={onAddFeederColumn}>
            Add Feeder Column
          </Button>
          <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={onOpenAddRowDialog}>
            Add Row
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
